import { type Plugin } from "chart.js";
import { set } from "lodash";
import { type ChartJSOrUndefined } from "react-chartjs-2/dist/types";

export const ALIGN_AXES_SCALE_PLUGIN_ID = "alignAxesScale";

export const alignAxesScalePlugin: Plugin = {
  id: ALIGN_AXES_SCALE_PLUGIN_ID,
};

export const updateScaleMax = (
  chart: ChartJSOrUndefined<any>,
  alignAxesScale: boolean,
) => {
  if (!chart) {
    return;
  }

  if (alignAxesScale) {
    const allScaleMax = [
      chart.scales.mainMetric.max,
      chart.scales.compare1.max,
      chart.scales.compare2.max,
      chart.scales.mainMetricBenchmark.max,
      chart.scales.compare1Benchmark.max,
      chart.scales.compare2Benchmark.max,
    ].filter(Boolean);
    const max = Math.max(...allScaleMax);
    set(chart, "config.options.scales.mainMetric.max", max);
    set(chart, "config.options.scales.compare1.max", max);
    set(chart, "config.options.scales.compare2.max", max);
    set(chart, "config.options.scales.mainMetricBenchmark.max", max);
    set(chart, "config.options.scales.compare1Benchmark.max", max);
    set(chart, "config.options.scales.compare2Benchmark.max", max);
  } else {
    set(chart, "config.options.scales.mainMetric.max", undefined);
    set(chart, "config.options.scales.compare1.max", undefined);
    set(chart, "config.options.scales.compare2.max", undefined);
    set(chart, "config.options.scales.mainMetricBenchmark.max", undefined);
    set(chart, "config.options.scales.compare1Benchmark.max", undefined);
    set(chart, "config.options.scales.compare2Benchmark.max", undefined);
  }
  chart.update();
};
